export var RelationalOperator;
(function (RelationalOperator) {
    RelationalOperator[RelationalOperator["Equal"] = 0] = "Equal";
    RelationalOperator[RelationalOperator["NotEqual"] = 1] = "NotEqual";
    RelationalOperator[RelationalOperator["GreaterThan"] = 2] = "GreaterThan";
    RelationalOperator[RelationalOperator["LessThan"] = 3] = "LessThan";
    RelationalOperator[RelationalOperator["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    RelationalOperator[RelationalOperator["LessOrEqual"] = 5] = "LessOrEqual";
})(RelationalOperator || (RelationalOperator = {}));
